import React, { useEffect, useRef, useState } from 'react';
import './Contact.css';

const Contact = () => {
  const contactHeroBackgroundRef = useRef(null);
  const backgroundRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      if (contactHeroBackgroundRef.current) {
        const scrolled = window.pageYOffset;
        const parallax = scrolled * 0.5;
        contactHeroBackgroundRef.current.style.transform = `translateY(${parallax}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the form data to a backend
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      organization: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      <section className="contact-hero">
        <div 
          ref={contactHeroBackgroundRef}
          className="contact-hero-background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/contact_hero.png)`
          }}
        ></div>
        <div className="container">
          <h1>Let’s Connect</h1>
          <p className="hero-description">
            Ready to amplify your impact? Let's start a conversation about how 
            we can help your organization achieve its goals.
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div
          className="contact-content-background"
          ref={backgroundRef}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/topo_map.png)`
          }}
          aria-hidden="true"
        />
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2>Contact Information</h2>
              <div className="info-item">
                <h3>Email</h3>
                <p>info@upnorthimpact.com</p>
              </div>
              <div className="info-item">
                <h3>Phone</h3>
                <p>336 287 7878</p>
              </div>
              <div className="info-item">
                <h3>Office Hours</h3>
                <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
                <p>Weekend consultations available by appointment</p>
              </div>
              <div className="info-item">
                <h3>Location</h3>
                <p>Elon, North Carolina</p>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="organization">Organization</label>
                  <input
                    type="text"
                    id="organization"
                    name="organization"
                    value={formData.organization}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-large">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
